import { use } from "react";
import APPUrls from "./app_urls";
import CommonSettings from "../utils/CommonSettings";

import { doGetRequest, doPostRequest } from "./fetchcalls";

export const get_product_licenses = async () => {
  let response = await doGetRequest(APPUrls.URL_GET_PRODUCT_LICENCES);
  return response;
};

export const get_product_licenses_for_user = async (userid) => {
  let response = await doGetRequest(
    APPUrls.URL_GET_PRODUCT_LICENCES_FOR_USER + "?userid=" + userid
  );
  return response;
};

export const get_products = async () => {
  let response = await doGetRequest(APPUrls.URL_GET_PRODUCTS);
  return response;
};

export const assign_licence = async (licencedetails) => {
  let url = APPUrls.URL_ASSIGN_LICENCE;
  let response = await doPostRequest(url, licencedetails);
  return response;
};

export const get_users = async (userid) => {
  let url = APPUrls.URL_GET_USERS + "?userid=" + userid;
  let response = await doPostRequest(url);
  return response;
};

export const add_user = async (user) => {
  let url = APPUrls.URL_ADD_USER;
  let response = await doPostRequest(url, user);
  return response;
};

export const update_assign_licence = async (licencedetails) => {
  let url = APPUrls.URL_UPDATE_ASSIGN_LICENCE;
  let response = await doPostRequest(url, licencedetails);
  return response;
};

export const remove_user_assigned_to_product = async (
  userid,
  noOflicenceassigned,
  productId,
  assignedByUserId
) => {
  let url = APPUrls.URL_REMOVE_USER_ASSIGNED_TO_PRODUCT + "?";
  if (userid) {
    url += "userid=" + userid + "&";
  }
  if (noOflicenceassigned !== null && noOflicenceassigned !== "") {
    url += "noOflicenceassigned=" + noOflicenceassigned + "&";
  }
  if (productId) {
    url += "productId=" + productId + "&";
  }
  if (assignedByUserId) {
    url += "assignedByUserId=" + assignedByUserId;
  }
  let response = await doPostRequest(url);
  return response;
};

export const remove_user = async (user) => {
  let url = APPUrls.URL_REMOVE_USER;

  let response = await doPostRequest(url, user);
  return response;
};

export const update_user = async (user) => {
  let url = APPUrls.URL_UPDATE_USER;

  let response = await doPostRequest(url, user);
  return response;
};

export const login_user = async (PhoneNumber, Password) => {
  let url = APPUrls.URL_LOGIN + "?";

  if (PhoneNumber) {
    url += "PhoneNumber=" + PhoneNumber + "&";
  }
  if (Password) {
    url += "Password=" + Password;
  }
  let response = await doGetRequest(url);
  return response;
};

export const get_assigned_products_to_user = async (userid) => {
  let url = APPUrls.URL_GET_ASSIGNED_PRODUCTS_TO_USER + "?";
  if (userid) {
    url += "userid=" + userid;
  }
  let response = await doGetRequest(url);
  return response;
};
